<template>
  <div class="profile_">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <b-container>
        <div class="wrapper">
          <div class="main-container">
            <div class="profile">
              <img
                src="../../assets/wall/wall2.jpg"
                alt=""
                class="profile-cover"
              />

              <div class="profile-info"></div>
              <div class="profile-menu">
                <div class="profile-avatar">
                  <div
                    class="avatar-initials profile-img"
                    width="50px"
                    height="50px"
                  ></div>
                  <!-- :class="`w${fav.class}`" -->

                  <div class="profile-name">{{ user.std_name }}</div>
                </div>
                <div class="menu-items nav nav-tabs">
                  <a
                    class="profile-menu-link active"
                    href="#tab_default_1"
                    data-toggle="tab"
                  >
                    ข้อมูลส่วนตัว
                  </a>

                  <a
                    class="profile-menu-link"
                    href="#tab_default_2"
                    data-toggle="tab"
                  >
                    ประวัติการยืม-คืน
                  </a>

                  <a
                    class="profile-menu-link"
                    href="#tab_default_3"
                    data-toggle="tab"
                  >
                    คูปอง
                  </a>
                </div>
                <div class="follow-buttons">
                  <button class="follow" v-if="this.profile.fines === 0">
                    ค่าปรับ
                  </button>
                  <button
                    class="follow follow-option"
                    v-if="this.profile.fines === 0"
                  >
                    {{ this.profile.fines }} บาท
                  </button>

                  <button class="follow-red" v-if="this.profile.fines !== 0">
                    ค่าปรับ
                  </button>
                  <button
                    class="follow-red follow-option"
                    v-if="this.profile.fines !== 0"
                  >
                    {{ this.profile.fines }} บาท
                  </button>
                </div>
              </div>
            </div>
            <br />
            <div class="tab-content">
              <div class="tab-pane active" id="tab_default_1">
                <b-card
                  class="border-light mb-4 shadow"
                  style="border-radius: 5px"
                  title=""
                  sub-title=""
                >
                  <b-card-text>
                    <div class="card-body d-flex flex-column text-left">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                          <strong>ชื่อ :</strong> {{ this.profile.std_name }}
                        </li>
                        <li class="list-group-item">
                          <strong>รหัสผู้ใช้ :</strong>
                          {{ this.profile.std_code }}
                        </li>

                        <li class="list-group-item">
                          <strong>สังกัด: </strong> {{ this.profile.fac_name }}
                        </li>
                        <li class="list-group-item">
                          <strong>รหัสผ่าน :</strong> หมายเลขโทรศัพท์ 4 ตัวหลัง
                        </li>
                      </ul>
                    </div>
                  </b-card-text>
                </b-card>
              </div>
              <div class="tab-pane" id="tab_default_2">
                <b-card
                  class="border-light mb-4 shadow"
                  style="border-radius: 5px"
                  title=""
                  sub-title=""
                >
                  <b-table
                    hover
                    :items="history"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    id="my-table"
                    head-variant="light"
                    class="text-left"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(borrow_date)="data">
                      {{ data.item.borrow_date | moment }}
                    </template>
                    <template #cell(return_date)="data">
                      {{ data.item.return_date | moment }}
                    </template>
                  </b-table>
                  <hr />
                  <div class="pagination-div">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      pills
                      align="right"
                    ></b-pagination>
                  </div>
                </b-card>
              </div>
              <div class="tab-pane" id="tab_default_3">
                <b-card
                  class="border-light mb-4 pt-0"
                  style="border-radius: 5px; background-color: #fafafa"
                  title=""
                  sub-title=""
                >
                  <!-- <b-card-text v-if="this.profile.fines !== 0">
                  <div class="d-flex flex-column" >
                    <img
                      src="../../assets/coupon/e-Coupon.gif"
                      alt=""
                      class="img-reward shadow"
                      style="border-radius:10px;"
                    />
                  </div>
                </b-card-text> -->

                  <!-- v-if="this.profile.fines === 0" -->
                  <b-card-text>
                    <i
                      class="fas fa-times-circle fa-lg"
                      style="color: Tomato"
                    ></i>
                    ไม่มีคูปอง
                  </b-card-text>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import CryptoJS from "crypto-js";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
export default {
  name: "profile",
  components: { sidebar_user },
  data() {
    return {
      items: [],
      orders: [],
      user: [],
      secret_one: "",
      keycomponent: "",
      datas: "",
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      get_user: [],
      access_token: "",
      profile: [],
      isShowcard: false,
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "book_title", label: "ชื่อหนังสือ", sortable: true },
        { key: "borrow_date", label: "วันที่ยืม", sortable: true },
        { key: "return_date", label: "วันที่ส่งคืน", sortable: true },
      ],
      perPage: 20,
      currentPage: 1,
      history: [],
    };
  },
  computed: {
    rows() {
      return this.history.length;
    },
  },
  mounted() {
    if (localStorage.getItem("booking") != null) {
      this.items = JSON.parse(localStorage.getItem("booking"));
    }
    if (localStorage.getItem("orders") != null) {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    }
    if (localStorage.getItem("auth") != null) {
      this.user = JSON.parse(localStorage.getItem("auth"));
      // console.log(this.user);
      this.profile = this.user;
      // console.log();
    }
    if (localStorage.getItem("access_token") != null) {
      this.access_token = localStorage.getItem("access_token");
      // console.log(this.access_token);
    }

    this.getIP();

    this.get_borrow();
    this.get_profile();
    var name_std = this.user.std_name;
    // this.chk_profile();
    // eslint-disable-next-line no-unused-vars
    var colors = [
      "#1abc9c",
      "#2ecc71",
      "#3498db",
      "#9b59b6",
      "#34495e",
      "#16a085",
      "#27ae60",
      "#2980b9",
      "#8e44ad",
      "#2c3e50",
      "#f1c40f",
      "#e67e22",
      "#e74c3c",
      "#95a5a6",
      "#f39c12",
      "#d35400",
      "#c0392b",
      "#bdc3c7",
      "#7f8c8d",
    ];

    var avatarElement = $(".avatar-initials"),
      avatarWidth = avatarElement.attr("width"),
      avatarHeight = avatarElement.attr("height"),
      // name = avatarElement.data('name'),
      name = name_std,
      initials =
        name.split(" ")[0].charAt(0).toUpperCase() +
        name.split(" ")[1].charAt(0).toUpperCase(),
      charIndex = initials.charCodeAt(0) - 65,
      colorIndex = charIndex % 19;

    avatarElement
      .css({
        "background-color": colors[colorIndex],
        width: avatarWidth,
        height: avatarHeight,
        font: avatarWidth / 2 + "px Arial",
        color: "#FFF",
        textAlign: "center",
        lineHeight: avatarHeight + "px",
        borderRadius: "50%",
      })
      .html(initials);
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      // if (date) {
      //   return moment(String(date)).format("MM/DD/YYYY");
      // }
      return moment(date).add(543, "year").format("LL");
    },
  },
  methods: {
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    get_profile() {
      let data = {
        token: this.token,
        std_code: this.user.std_code,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_profile", data, {
          headers,
        })
        .then((res) => {
          // console.log("res",res.data.profile);
          this.profile = res.data.profile;
          // console.log(this.profile);
          this.history = res.data.profile.history;
          // console.log(this.history);
          this.isShowcard = res.data.profile.isshowcard;
        });
    },
    chk_profile() {
      setInterval(() => {
        let data = {
          token: this.token,
          std_code: this.user.std_code,
        };
        // console.log(data);
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/get_profile",
            data,
            {
              headers,
            }
          )
          .then((res) => {
            if (res.data.profile.isshowcard === false) {
              this.get_profile();
            }
            // console.log("res",res.data.profile);
            // this.profile = res.data.profile;
            // // console.log(this.profile);
            // this.history = res.data.profile.history;
            // // console.log(this.history);
            // this.isShowcard = res.data.profile.isshowcard;
          });
      }, 5000);
    },
    get_borrow() {
      let curdate = new Date();
      curdate.setUTCHours(curdate.getUTCHours() + 7);
      let timespit = curdate.toISOString().slice(0, 13).split("T");
      let objDate = {
        date: timespit[0],
        time: timespit[1],
      };

      // /******************************************LOCAL STORANGE**************************************************************** */

      // let std_code = localStorage.getItem("std_code");

      this.keycomponent =
        "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
      this.secret_one = this.keycomponent + objDate.date + " " + objDate.time;
      this.datas = {
        ciphertext: "",
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
      };
      let IP = localStorage.getItem("IP");
      let std;
      std = {
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
        std_code: this.user.std_code,
        public_ip: IP,
      };
      // console.log(std);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_loan_all", std, {
          headers,
        })
        .then(() => {
          // console.log("res");
          // console.log(res.data[0]);
        });
    },
    encrypt_data(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(this.secret_one).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      this.datas.ciphertext = CryptoJS.AES.encrypt(plaintext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      passphrase = "";
      return {
        data: this.encrypt_once(JSON.stringify(this.datas), secret).toString(),
      };
    },

    encrypt_once(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let ciptext = CryptoJS.AES.encrypt(JSON.stringify(plaintext), key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      return ciptext;
    },

    decrypt_once(ciphertext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let bytes = CryptoJS.AES.decrypt(ciphertext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      });
      let decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}

.space {
  height: 100px;
}
.space2 {
  height: 30px;
}
a {
  color: #3e3e3e;
}
.tab-pane .card-body {
  padding: 0;
}
/* make sidebar nav vertical */
.avatar-initials {
  /* position: absolute;*/
  padding: 12px 12px;
}
a:hover {
  text-decoration: none;
}
.main-container {
  padding: 25px;
  flex-grow: 1;
  overflow: auto;
}
/* */
.avatar {
  margin-left: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  /* background: coral; */
  /* text-align: center; */
}
.avatar-img {
  width: 50%;
  height: 100%;
}
.avatar-tab {
  margin-left: 18px;
  margin-right: auto;
  /* text-align: center; */
}
.wrapper {
  width: 100%;
  display: flex;
  flex-grow: 1;
  overflow: auto;
  z-index: -1;
  /*background-color: #ffffff;*/
}
/* */

/*profile*/
.menu-items {
  display: flex;
  cursor: pointer;
}

.profile {
  height: 45vh;
  /* max-height: 350px;
    min-height: 270px;*/
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.profile-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
  border-radius: 4px 4px 6px 6px;
}

.profile-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;
  box-shadow: -1px 3px 8px -1px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
  padding: 0 25px;
  z-index: 2;
}

.profile-img {
  border-radius: 50%;
  width: 42px;
  height: 42px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 15px;
}

.profile-avatar {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.profile-name {
  white-space: nowrap;
  font-family: "Kanit", sans-serif;
}

.profile-menu-link {
  padding: 20px;
  transition: 0.2s;
}
.profile-menu-link.active,
.profile-menu-link:hover {
   /*#f13a2f;*/
  border-bottom: 3px solid #fc4170;
  color: #fc4170;
}

.profile-info {
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  z-index: 2;
}

.profile-name {
  color: #808080;
}

.profile-item {
  display: flex;
  align-items: center;
  color: #fff;
  padding: 26px 16px;
  white-space: nowrap;
  font-family: "Kanit", sans-serif;
}
.profile-item svg {
  width: 22px;
  margin-right: 10px;
}

.profile-contact-info {
  position: absolute;
  display: flex;
  right: 10px;
  top: 20px;
  color: #fff;
}
.profile-contact-info svg {
  width: 18px;
}

.profile-contact {
  border: 1px solid rgba(239, 239, 239, 0.3);
  padding: 16px;
  margin-left: 10px;
  border-radius: 50%;
  cursor: pointer;
}

@media (max-width: 1030px) {
  .profile-name {
    display: none;
  }

  .profile-menu-link {
    padding: 10px 5px;
    font-size: 15px;
  }
}

@media (max-width: 900px) {
  .profile-item {
    padding: 20px 10px;
  }
}
@media (max-width: 840px) {
  .profile-contact {
    padding: 6px;
  }

  .profile-item,
  .profile-avatar {
    flex-direction: column;
    font-family: "Kanit", sans-serif;
  }

  .profile-item svg {
    margin-right: 0;
  }

  .profile-item {
    text-align: center;
    font-family: "Kanit", sans-serif;
  }

  .profile-img {
    margin-right: 0;
    margin-top: 10px;
  }

  .profile-name {
    display: block;
    margin-bottom: 10px;
    margin-top: 6px;
  }

  .profile-menu {
    flex-direction: column;
  }

  .menu-items {
    order: 1;
  }
}
@media (max-width: 980px) {
  .profile {
    min-height: 380px;
    max-height: 380px;
  }
}

@media screen and (min-width: 1024px) {
  #card-mobile {
    display: none;
  }
}
@media screen and (min-width: 375px) and (max-width: 960px) {
  #card-mobile {
    display: block;
  } /* hide it small screens */
}

@media (min-width: 991px) and (max-width: 1200px) {
  .skill-block {
    padding: 32px !important;
  }

  .img-reward {
    width: 100%;
    height: 100%;
    margin-right: auto;
    margin-left: auto;
    /* color: rgb(189, 0, 63); */
  }
}
@media (min-width: 1200px) {
  .skill-block {
    padding: 56px !important;
  }
}

/*  */

/*card*/

.card {
  font-family: "Kanit", sans-serif;
}
.card-title {
  font-family: "Kanit", sans-serif;
}
.card-body {
  font-family: "Kanit", sans-serif;
}
.card-text {
  font-family: "Kanit", sans-serif;
}
/*end*/
.nav-tabs {
  border-bottom: 1px solid #ffffff;
}
.nav-pills .nav-link.active {
  color: #e23770;
  background-color: #fac1d4bb;
  padding: 5px 15px;
}
.nav-tabs {
  border-radius: 0;
  box-shadow: none;
}
/**/

.follow-buttons {
  display: flex;
  font-family: "Kanit", sans-serif;
}

.follow {
  border: 2px solid #efefef;
  border-radius: 25px 0 0 25px;
  color: #b3b3b3;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background-color: transparent;
  font-family: "Kanit", sans-serif;
}
.follow:hover {
  background-color: #ffffff;
}

/* border-bottom: 3px solid #f13a2f;
    color: #f13a2f; */
.follow-red {
  border: 2px solid #ff0000;
  border-radius: 25px 0 0 25px;
  color: #ff0000;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background-color: transparent;
  font-family: "Kanit", sans-serif;
}
.follow:hover {
  background-color: #ffffff;
}
.follow-option {
  border-radius: 0 25px 25px 0;
  margin-left: -2px;
}

@-webkit-keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
